import Vue from "vue"
import Vuetify from "vuetify/lib"

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'md',  // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
  },
  theme: {
    dark: false,
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#2563EB",
        secondary: "#64748B",
        accent: "#6366F1",
        error: "#DC2626",
        info: "#0EA5E9",
        success: "#16A34A",
        warning: "#F59E0B",
      },
    },
  },
})